<template>
  <div class="keyboard-wrapper">
    <div class="keyboard-k2 lite Outline">
      <div
        v-for="(rowValue, rowKey) in keyboardData"
        class="row dark"
        :class="rowKey"
        :key="rowKey"
      >
        <div
          v-for="(value, key) in rowValue"
          class="ghosting active"
          :class="key"
          :key="key"
        >
          <svg
            height="67px"
            :width="getKeyWidth(key)"
            v-html="value"
          ></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// row 0
import KeyTilde from 'assets/svg/keyboards/k2-keys-lite/KeyTilde.svg';
import Key0 from 'assets/svg/keyboards/k2-keys-lite/Key0.svg';
import Key1 from 'assets/svg/keyboards/k2-keys-lite/key1.svg';
import Key2 from 'assets/svg/keyboards/k2-keys-lite/key2.svg';
import Key3 from 'assets/svg/keyboards/k2-keys-lite/key3.svg';
import Key4 from 'assets/svg/keyboards/k2-keys-lite/key4.svg';
import Key5 from 'assets/svg/keyboards/k2-keys-lite/key5.svg';
import Key6 from 'assets/svg/keyboards/k2-keys-lite/key6.svg';
import Key7 from 'assets/svg/keyboards/k2-keys-lite/key7.svg';
import Key8 from 'assets/svg/keyboards/k2-keys-lite/key8.svg';
import Key9 from 'assets/svg/keyboards/k2-keys-lite/key9.svg';
import KeyDash from 'assets/svg/keyboards/k2-keys-lite/KeyDash.svg';
import KeyEqual from 'assets/svg/keyboards/k2-keys-lite/KeyEqual.svg';
import KeyBackspace from 'assets/svg/keyboards/k2-keys-lite/KeyBackspace.svg';
// row 1
import KeyTab from 'assets/svg/keyboards/k2-keys-lite/KeyTab.svg';
import KeyQ from 'assets/svg/keyboards/k2-keys-lite/KeyQ.svg';
import KeyW from 'assets/svg/keyboards/k2-keys-lite/KeyW.svg';
import KeyE from 'assets/svg/keyboards/k2-keys-lite/KeyE.svg';
import KeyR from 'assets/svg/keyboards/k2-keys-lite/KeyR.svg';
import KeyT from 'assets/svg/keyboards/k2-keys-lite/KeyT.svg';
import KeyY from 'assets/svg/keyboards/k2-keys-lite/KeyY.svg';
import KeyU from 'assets/svg/keyboards/k2-keys-lite/KeyU.svg';
import KeyI from 'assets/svg/keyboards/k2-keys-lite/KeyI.svg';
import KeyO from 'assets/svg/keyboards/k2-keys-lite/KeyO.svg';
import KeyP from 'assets/svg/keyboards/k2-keys-lite/KeyP.svg';
import KeyBracket1 from 'assets/svg/keyboards/k2-keys-lite/KeyBracket1.svg';
import KeyBracket2 from 'assets/svg/keyboards/k2-keys-lite/KeyBracket2.svg';
import KeyBSlash from 'assets/svg/keyboards/k2-keys-lite/KeyBSlash.svg';
// row 2
import KeyCapLock from 'assets/svg/keyboards/k2-keys-lite/KeyCapLock.svg';
import KeyA from 'assets/svg/keyboards/k2-keys-lite/KeyA.svg';
import KeyS from 'assets/svg/keyboards/k2-keys-lite/KeyS.svg';
import KeyD from 'assets/svg/keyboards/k2-keys-lite/KeyD.svg';
import KeyF from 'assets/svg/keyboards/k2-keys-lite/KeyF.svg';
import KeyG from 'assets/svg/keyboards/k2-keys-lite/KeyG.svg';
import KeyH from 'assets/svg/keyboards/k2-keys-lite/KeyH.svg';
import KeyJ from 'assets/svg/keyboards/k2-keys-lite/KeyJ.svg';
import KeyK from 'assets/svg/keyboards/k2-keys-lite/KeyK.svg';
import KeyL from 'assets/svg/keyboards/k2-keys-lite/KeyL.svg';
import KeySemicolon from 'assets/svg/keyboards/k2-keys-lite/KeySemicolon.svg';
import KeyApost from 'assets/svg/keyboards/k2-keys-lite/KeyApost.svg';
import KeyEnter from 'assets/svg/keyboards/k2-keys-lite/KeyEnter.svg';
// row 3
import KeyShift1 from 'assets/svg/keyboards/k2-keys-lite/KeyShift1.svg';
import KeyZ from 'assets/svg/keyboards/k2-keys-lite/KeyZ.svg';
import KeyX from 'assets/svg/keyboards/k2-keys-lite/KeyX.svg';
import KeyC from 'assets/svg/keyboards/k2-keys-lite/KeyC.svg';
import KeyV from 'assets/svg/keyboards/k2-keys-lite/KeyV.svg';
import KeyB from 'assets/svg/keyboards/k2-keys-lite/KeyB.svg';
import KeyN from 'assets/svg/keyboards/k2-keys-lite/KeyN.svg';
import KeyM from 'assets/svg/keyboards/k2-keys-lite/KeyM.svg';
import KeyComma from 'assets/svg/keyboards/k2-keys-lite/KeyComma.svg';
import KeyPeriod from 'assets/svg/keyboards/k2-keys-lite/KeyPeriod.svg';
import KeyFSlash from 'assets/svg/keyboards/k2-keys-lite/KeyFSlash.svg';
import KeyShift2 from 'assets/svg/keyboards/k2-keys-lite/KeyShift2.svg';
// row 4
import KeySpace from 'assets/svg/keyboards/k2-keys-lite/KeySpace.svg';

export default {
  data() {
    return {
      keyboardData: {
        row0: {
          KeyTilde,
          Key1,
          Key2,
          Key3,
          Key4,
          Key5,
          Key6,
          Key7,
          Key8,
          Key9,
          Key0,
          KeyDash,
          KeyEqual,
          KeyBackspace
        },
        row1: {
          KeyTab,
          KeyQ,
          KeyW,
          KeyE,
          KeyR,
          KeyT,
          KeyY,
          KeyU,
          KeyI,
          KeyO,
          KeyP,
          KeyBracket1,
          KeyBracket2,
          KeyBSlash
        },
        row2: {
          KeyCapLock,
          KeyA,
          KeyS,
          KeyD,
          KeyF,
          KeyG,
          KeyH,
          KeyJ,
          KeyK,
          KeyL,
          KeySemicolon,
          KeyApost,
          KeyEnter
        },
        row3: {
          KeyShift1,
          KeyZ,
          KeyX,
          KeyC,
          KeyV,
          KeyB,
          KeyN,
          KeyM,
          KeyComma,
          KeyPeriod,
          KeyFSlash,
          KeyShift2
        },
        row4: {
          KeySpace
        }
      }
    };
  },
  methods: {
    getKeyWidth(keyName) {
      switch (keyName) {
        case 'KeyBackspace':
        case 'KeyTab': {
          return '101px';
        }
        case 'KeySpace': {
          return '402px';
        }
        case 'KeyEnter': {
          return '116px';
        }
        case 'KeyShift1': {
          return '150px';
        }
        case 'KeyShift2': {
          return '152px';
        }
        case 'KeyCapLock': {
          return '119px';
        }
        default: {
          return '67px';
        }
      }
    }
  }
};
</script>
